seedWebApp.controller('IndexIntegrationsCtrl', ['$scope', '$routeParams', '$location', '$window', '$timeout',
    function ($scope, $routeParams, $location, $window, $timeout) {

        $scope.defaultPages = [
            { pageIndex: 0, pageLabel: 'Integrações', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/integrations.html' },
            { pageIndex: 1, pageLabel: 'Integrações Recentes', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/integrationRecents.html' },
            { pageIndex: 2, pageLabel: 'FTP Server', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/ftp.html' },                        
        ];

        /*
        if ($scope.loggedUser && $scope.loggedUser.UserID.includes('@seed.com.br')) {
            $scope.defaultPages.push({ pageIndex: 3, pageLabel: 'Integrador Totvs', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/integrationApp.html' });
            $scope.defaultPages.push({ pageIndex: 4, pageLabel: 'Database Scripts', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/databaseScripts.html' });
            $scope.defaultPages.push({ pageIndex: 5, pageLabel: 'Tracking', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/tracking.html' });
        }
        */

        /*
        $timeout(function () {
            console.log('DEV TOOLS');

            if ($scope.loggedUser && $scope.loggedUser.UserID == 'jamesm@seed.com.br') {
                //$scope.defaultPages.push({ pageIndex: 3, pageLabel: 'Tipos de Integrações', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/dicIntegrations.html' });             
            }
        }, 1000);
        */

      
        //if ($scope.loggedUser && $scope.loggedUser.UserID.includes('@seed.com.br')) {
        //    $scope.defaultPages.push({ pageIndex: 3, pageLabel: 'Integrador Totvs', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/integrationApp.html' });
        //    $scope.defaultPages.push({ pageIndex: 4, pageLabel: 'Database Scripts', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/databaseScripts.html' });
        //    $scope.defaultPages.push({ pageIndex: 5, pageLabel: 'Tracking', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/tracking.html' });
        //}

        //$timeout(function () {
        //    console.log('Timeout ' + $scope.loggedUser.UserID);            
        //}, 5000);

        $scope.$watch('loggedUser', function () {
            if ($scope.loggedUser) {
                console.log('LOGGEDUSER LOADED ' + $scope.loggedUser.UserID);
                if ($scope.loggedUser && $scope.loggedUser.UserID.includes('@seed.com.br')) {
                    console.log('DEV TOOLS');
                    $scope.defaultPages.push({ pageIndex: 3, pageLabel: 'Integrador Totvs', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/integrationApp.html' });
                    $scope.defaultPages.push({ pageIndex: 4, pageLabel: 'Database Scripts', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/databaseScripts.html' });
                    
                }

                console.log('logged user', $scope.loggedUser);
                if ($scope.loggedUser && $scope.loggedUser.UserRoleID == 'Admin') {
                    $scope.defaultPages.push({ pageIndex: 5, pageLabel: 'Tracking', pageDisplay: 'Integrations', pageUrl: 'SPA/Integrations/tracking.html' });
                }
            }
        });

        $scope.$watch('modules', function () {
            if ($scope.modules) {
                $scope.verifyPermsAndDefineTabs($scope, 'Integrations');
            }            
        });

        $scope.loadingTabs = true;
        $scope.selTab = $routeParams.Tab;

        $scope.tabSelected = function (page) {
            $location.search('Tab', page.pageIndex);
            $scope.selectedIndex = page.pageIndex;
        };

        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize();


        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

        
    }
]);